import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import qs from 'query-string'
import { Company } from '../types'
import { CreateCompanyFormValues } from '@/modals/CompanyModals/CreateCompany'

export const getCompaniesByTag = async (
    payload: DataGridPayload
): Promise<ResponseArray<Company>> => {
    const response = await datacentral.get(
        `/companies?${qs.stringify(payload)}`
    )
    return response.data
}

export const createCompany = async (values: {
    company: CreateCompanyFormValues
}): Promise<ResponseObject<Company>> => {
    const response = await datacentral.post('/companies', values)
    return response.data
}

export const getCompaniesOptions = async (value: string) => {
    const response = await getCompaniesByTag({
        page: 1,
        page_size: 5,
        q: value,
    })

    if (!response?.results?.length) return []

    return response?.results?.map((item) => ({
        label: `${item?.company_tax} - ${item?.company_name}`,
        value: item?.company_id,
        company_industry: item?.company_industry,
        company_website: item?.company_website,
    }))
}

export const updateCompany = async (values: {
    company: Omit<
        Company,
        'company_id' | 'company_created_at' | 'company_updated_at'
    >
    company_id: number
}): Promise<ResponseObject<Company>> => {
    const response = await datacentral.put(
        '/companies' + `/${values?.company_id}`,
        values?.company
    )
    return response.data
}

export const getCompanyById = async (
    id: number
): Promise<ResponseObject<Company>> => {
    const response = await datacentral.get(`/companies/${id}`)
    return response.data
}

// Lookup company by tax code (external API)
export interface CompanyLookupResult {
    name: string
    tax_code: string
    address?: string
    phone?: string
    representative?: string
}

export const lookupCompanyByTaxCode = async (
    taxCode: string
): Promise<ResponseObject<CompanyLookupResult>> => {
    const response = await datacentral.get(`/companies/lookup/${taxCode}`)
    return response.data
}
